import React from 'react'
import Select from 'react-select'
import { isEqual } from 'lodash'
import { fnum, sortOpts } from '../../utils/utils'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import Form from '../ui/Form'

class ExpenseListPmnt extends Form {

  constructor(props){
    super(props);
    this.state = {
      editing: false,
      delConf: false,
      data: props.data,
      errors: {}
    }
  }

  saveExpense = () => {
    const { data } = this.state;
    if(isEqual(this.props.data, data)){
      this.cancelEditing();
    }
    else {
      this.props.editExpense(data, (err) => {
        if(err){
          this.setState({
            errors: err
          });
          return false;
        }
        this.cancelEditing();
      });
    }
  }

  makePayment = e => {
    e.stopPropagation();
    this.props.editExpense({
      ...this.state.data,
      post_payed: 1
    }, (err) => {
      if(err){
        this.setState({
          errors: err
        });
      }
      else {
        this.setState({
          errors: {}
        });
      }
    });
  }

  deleteItem = () => {
    this.props.editExpense({
      ...this.props.data,
      post_active: 0
    }, this.cancelEditing);
  }

  render() {
    const { srvcs, srvgs, data } = this.props;
    const { errors, data: nData } = this.state;
    const postSum = fnum(("" + nData.post_price).replace(',','.') *
      ("" + nData.post_qntt).replace(',','.'));
    const { srvc_type } = srvcs[data.post_srvc_id];
    const postPayedColor = data.post_payed ? 'green' : (
      data.post_bdate <= moment().format('Y-MM-DD') ? 'red' : 'black'
    );
    const postPayedLabel = srvc_type === -1 ?
      <div style={{color: postPayedColor}}>
        {data.post_payed ? 'Оплачено' : 'Не оплачено'}
      </div>
      : [];
    const postPayedInput = srvc_type === -1 ?
      <div className="checkbox">
        <label>
          <input type="checkbox" checked={nData.post_payed}
            name="post_payed" onChange={this.handleChBox} /> Оплачено
        </label>
      </div>
      : [];

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    var srvcsOpt = [];
    for (var key in srvcs){
      if(srvcs.hasOwnProperty(key) && ((srvcs[key].srvc_active === 1
        && srvcs[key].srvc_type === -1) || parseInt(key,10) === data.post_srvc_id)) {
        srvcsOpt.push({value:srvcs[key].srvc_id,label:srvcs[key].srvc_desc});
      }
    }
    srvcsOpt.sort(sortOpts);

    const error = errors.form && (
      <div className="text-danger">{errors.form}</div>
    );

    if(this.state.editing){
      return(
        <tr>
          <td>
            {delConf}
            <div className="form-group">
              <Select
                clearable={false}
                options={srvcsOpt}
                value={nData.post_srvc_id}
                onChange={e => this.updateSelect(e,'post_srvc_id')}
                placeholder="Услуга"
              />
            </div>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.post_desc}
                name="post_desc"
                onChange={this.updateInput}
                placeholder="Описание"
              />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveExpense}  title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
            </div>
            {error}
          </td>
          <td>
            <input type="text"
              className="form-control"
              value={nData.post_price}
              name="post_price"
              onChange={this.updateInput}
              placeholder="Цена" title="Цена"
            />
            <center>x</center>
            <input type="text"
              className="form-control"
              value={nData.post_qntt}
              name="post_qntt"
              onChange={this.updateInput}
              placeholder="Кол-во" title="Кол-во"
            />
            <center>= {postSum}</center>
          </td>
          <td>
            <DatePicker
              className="form-control"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={moment(nData.post_bdate)}
              onChange={e => this.updateDate(e, 'post_bdate')}
            />
          </td>
          <td></td>
          <td>
            {srvgs[srvcs[nData.post_srvc_id].srvc_srvg_id].srvg_desc}
          </td>
          <td>
            {postPayedInput}
            <textarea type="text"
              className="form-control"
              value={nData.post_note || ''}
              name="post_note"
              onChange={this.updateInput}
              placeholder="Заметка"
              title="Заметка"
            />
          </td>
        </tr>
      );
    }
    else{
      return (
        <tr className="text-success" onClick={this.startEditing}>
          <td style={{paddingLeft: "50px"}}>
            {srvcs[data.post_srvc_id].srvc_desc+((""+data.post_desc) ? ": "+data.post_desc : "")}
            {error}
          </td>
          <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
          <td>{moment(data.post_bdate).format('L')}</td>
          <td></td>
          <td>{srvgs[srvcs[data.post_srvc_id].srvc_srvg_id].srvg_desc}</td>
          <td className="hover-popup-container">
            <div>
              {postPayedLabel}
            </div>
            <div>
              {data.post_note}
            </div>
            <div
              className="hover-popup"
            >
              {!data.post_payed && (
                <button
                  className="btn btn-success"
                  onClick={this.makePayment}
                >
                  Оплатить
                </button>
              )}
            </div>
          </td>
        </tr>
      );
    }

  }
}

export default ExpenseListPmnt;



// WEBPACK FOOTER //
// ./src/components/expense/ExpenseListPmnt.js